import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MessageCircle, X } from "lucide-react";

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    api.get("/branches").then(({ data }) => {
      setBranches((data || []).filter((b) => b.whatsapp));
    }).catch(() => {});
  }, []);

  if (branches.length === 0) return null;

  // If exactly one branch has WhatsApp, single-click opens it. Otherwise show a small picker.
  if (branches.length === 1) {
    const b = branches[0];
    return (
      <a
        href={`https://wa.me/${b.whatsapp}?text=${encodeURIComponent("Hi JAS, I have a question about ")}`}
        target="_blank" rel="noreferrer"
        data-testid="whatsapp-fab"
        className="fixed bottom-20 right-6 z-40 inline-flex items-center gap-2 pl-4 pr-5 py-3 bg-[#25D366] hover:bg-[#1da851] text-white font-semibold rounded-full shadow-lg shadow-emerald-500/30 transition-all hover:scale-105"
        aria-label={`Chat with ${b.name} on WhatsApp`}
      >
        <MessageCircle size={20} />
        <span className="hidden sm:inline text-sm">Chat with us</span>
      </a>
    );
  }

  return (
    <div className="fixed bottom-20 right-6 z-40" data-testid="whatsapp-fab">
      {open && (
        <div className="mb-3 bg-white border border-slate-200 rounded-xl shadow-xl p-4 w-72">
          <div className="flex items-center justify-between mb-3">
            <div className="font-display font-bold text-sm text-[#0b1838]">Chat with a branch</div>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-700"><X size={16} /></button>
          </div>
          <ul className="space-y-2">
            {branches.map((b) => (
              <li key={b.id}>
                <a
                  href={`https://wa.me/${b.whatsapp}?text=${encodeURIComponent("Hi JAS, I have a question about ")}`}
                  target="_blank" rel="noreferrer"
                  data-testid={`whatsapp-fab-branch-${b.id}`}
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors"
                >
                  <div className="p-2 bg-[#25D366] text-white rounded-full"><MessageCircle size={14} /></div>
                  <div className="flex-1">
                    <div className="text-sm font-semibold text-[#0b1838]">{b.name.replace("JAS Computers & Mobiles — ", "")}</div>
                    <div className="text-xs text-slate-500">{b.phone || "WhatsApp"}</div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        className="inline-flex items-center gap-2 pl-4 pr-5 py-3 bg-[#25D366] hover:bg-[#1da851] text-white font-semibold rounded-full shadow-lg shadow-emerald-500/30 transition-all hover:scale-105"
        aria-label="Open WhatsApp menu"
      >
        <MessageCircle size={20} />
        <span className="hidden sm:inline text-sm">Chat with us</span>
      </button>
    </div>
  );
}
